import { useAdminUser } from '../../hooks/usePermission'
import { useTheme } from '../../hooks/useTheme'
import { signOut } from '../../services/auth'
import { formatRole } from '../../utils/formatRole'

function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme()

  const cycleTheme = () => {
    if (theme === 'light') setTheme('dark')
    else if (theme === 'dark') setTheme('system')
    else setTheme('light')
  }

  return (
    <button
      onClick={cycleTheme}
      className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
      title={`Theme: ${theme} (${resolvedTheme})`}
    >
      {resolvedTheme === 'dark' ? (
        <svg className="w-5 h-5 text-gray-600 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      ) : (
        <svg className="w-5 h-5 text-gray-600 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      )}
    </button>
  )
}

export function TopNav() {
  const { email, role } = useAdminUser()

  return (
    <header className="fixed left-0 right-0 top-0 z-50 h-20 border-b border-border-card bg-white dark:bg-[#0f0d12] dark:border-[#3d2c4f] transition-colors">
      <div className="flex h-full items-center justify-between px-6">
        <div className="flex items-center gap-3">
          <img src="/appIcon.svg" alt="Barta" className="h-10 w-10 rounded-lg" />
          <h1 className="font-heading text-2xl font-bold text-[#503864] dark:text-[#b58fcc]">Admin</h1>
        </div>

        <div className="flex items-center gap-4">
          <ThemeToggle />
          <div className="text-right">
            <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{email}</p>
            <p className="text-xs text-gray-500 dark:text-gray-400">{formatRole(role)}</p>
          </div>
          <div className="h-10 w-10 rounded-full bg-[#503864]/10 dark:bg-[#7f4f9a]/20 flex items-center justify-center">
            <span className="text-sm font-bold text-[#503864] dark:text-[#b58fcc]">
              {email?.charAt(0).toUpperCase()}
            </span>
          </div>
          <button
            onClick={async () => {
              await signOut()
              localStorage.removeItem('access_token')
              window.location.href = '/'
            }}
            className="p-2 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
            title="Sign out"
          >
            <svg className="w-5 h-5 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  )
}
